<button type="button" class="chat-button" (click)="open()"
  [attr.aria-label]="'chat.open' | t" [title]="'chat.title' | t">
  <mat-icon [matBadge]="badge" [matBadgeHidden]="total === 0" matBadgeColor="warn" matBadgeSize="small"
    aria-hidden="false">chat_bubble_outline</mat-icon>
</button>
